// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"playlistModalStyles_customCheckbox__3sKph","customCheckboxIcon":"playlistModalStyles_customCheckboxIcon__25CSL"};